import {BubbleFlyingBehaviour, FlyingBubble} from "js/Elements/BubbleFlyingBehaviour";
import {GameGrid} from "js/Elements/GameGrid";
import {ShooterFlyingBubble} from "js/Elements/ShooterFlyingBubble";
import { game } from '../main';

export class FlyingBubblesGroup extends Phaser.Group {
  public onGridCollision = new Phaser.Signal();

  private activeBubbles: FlyingBubble[] = [];

  private flyingBehaviour: BubbleFlyingBehaviour;

  private grid: GameGrid;

    constructor(grid: GameGrid) {
        super(game);
        this.flyingBehaviour = new BubbleFlyingBehaviour(grid);
        this.grid = grid;
    }

    public addShooterBubble(bubble: ShooterFlyingBubble) {
      this.activeBubbles.push(bubble);
      bubble.onCollision.add(() => {
        this.grid.putBubble(bubble);
        bubble.destroy();
        this.activeBubbles.splice(this.activeBubbles.indexOf(bubble), 1);
      });
    }

    public simulate(bubble: FlyingBubble) {
      return this.flyingBehaviour.simulate(bubble, 100);
    }

    public update() {
      this.activeBubbles.forEach(bubble => {
        this.flyingBehaviour.update(bubble);
      });
    }
}
